import React from 'react';
import { Container } from 'react-bootstrap';
import { fadeIn } from '../../../Litho/Functions/GlobalAnimations';
import IconWithText from '../../../Litho/Components/IconWithText/IconWithText';

const highlights = [
	{
		title: 'Express air cargo',
		content:
			'Priority air freight for urgent shipments and tight deadlines, worldwide.',
		icon: 'line-icon-Plane text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] via[#f767a6] to-[#ff798e]',
	},
	{
		title: 'Door-to-door delivery',
		content:
			'Integrated pickup and final-mile delivery for seamless end-to-end service.',
		icon: 'line-icon-Navigation-LeftWindow text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] via[#f767a6] to-[#ff798e]',
	},
	{
		title: 'Temperature-controlled',
		content:
			'Specialized handling for pharma, perishables, and sensitive cargo.',
		icon: 'line-icon-Like-2 text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] via[#f767a6] to-[#ff798e]',
	},
	{
		title: 'Customs brokerage',
		content: 'Expert documentation and compliance to clear cargo fast.',
		icon: 'line-icon-Talk-Man text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] via[#f767a6] to-[#ff798e]',
	},
	{
		title: 'Real-time tracking',
		content: 'Live milestone updates and proactive exception alerts.',
		icon: 'line-icon-Like-2 text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] via[#f767a6] to-[#ff798e]',
	},
	{
		title: 'Global network',
		content: 'Capacity on major lanes with reliable airline partnerships.',
		icon: 'line-icon-Globe text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] via[#f767a6] to-[#ff798e]',
	},
];

const ServicesHighlights = () => {
	return (
		<section className='py-[130px] lg:py-[95px] md:py-[75px] sm:py-[50px] xs:px-[15px] bg-lightgray'>
			<Container>
				<IconWithText
					grid='row-cols-1 row-cols-lg-3 row-cols-sm-2 row-gap-4'
					theme='icon-with-text-10'
					data={highlights}
					animation={fadeIn}
					animationDelay={0.1}
				/>
			</Container>
		</section>
	);
};

export default ServicesHighlights;
